import { render, staticRenderFns } from "./DisclosureTriangle.vue?vue&type=template&id=466cd43c&scoped=true&"
import script from "./DisclosureTriangle.vue?vue&type=script&lang=js&"
export * from "./DisclosureTriangle.vue?vue&type=script&lang=js&"
import style0 from "./DisclosureTriangle.vue?vue&type=style&index=0&id=466cd43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466cd43c",
  null
  
)

export default component.exports